export default __webpack_public_path__ + "media/carousel/wepresent-af6801b2.png";